export const BASE_ENDPOINT = process.env.VUE_APP_VERIFICATE_API_URL
export const ANEXO_20_ENDPOINT = process.env.VUE_APP_ANEXO_20_API_URL
// export const API_V1 = `${BASE_ENDPOINT}/api/v1/`
// export const GENERATE_PDF_ENDPOINT = process.env.VUE_APP_VERIFICATE_GENERATE_PDF_API_URL
